module.exports = __webpack_public_path__ + "static/media/top__video-frame.99072c3e.png";